import { Routes, Route } from 'react-router-dom';
import MainPage from "./views/MainPage/index";
import AdminPage from "./views/AdminPage/index";
import EmailVerificationPage from "./views/EmailVerificationPage";
import ResetPasswordPage from "./views/ResetPasswordPage";
import NotFoundPage from "./views/NotFoundPage";
import ProtectedRoute from "./components/ProtectedRoute";
import DetectionImageViewer from "./views/DetectionImageViewer";
 
// Add this route in your Routes:
<Route path="/detection-image-viewer" element={<DetectionImageViewer />} />
function App() {
return (
    <Routes>
      <Route
        path="/"
        element={
          <ProtectedRoute type="public">
            <MainPage />
          </ProtectedRoute>
        }
      />
 
      <Route
        path="/admin"
        element={
          <ProtectedRoute type="admin">
            <AdminPage />
          </ProtectedRoute>
        }
      />
 
      <Route
        path="/verify-email"
        element={
          <ProtectedRoute type="email-verification">
            <EmailVerificationPage />
          </ProtectedRoute>
        }
      />
 
      <Route
        path="/__/auth/action"
        element={
          <ProtectedRoute type="password-reset">
            <ResetPasswordPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/detection-image-viewer"
        element={
          <ProtectedRoute type="admin">
            <DetectionImageViewer />
          </ProtectedRoute>
        }
      />

      <Route
        path="*"
        element={
          <ProtectedRoute type="public">
            <NotFoundPage />
          </ProtectedRoute>
        }
      />
    </Routes>
  );
}
 
export default App;
